export default "__VITE_ASSET__BTnvepxS__"